import React from 'react';
import PropTypes from 'prop-types';
import magnifyingGlassIcon from './images/magnifying-glass-icon.svg';
import './Search.css';

const Search = ({ keyword, handleChange }) => (
    <form className="search-form" onSubmit={event => {
        event.preventDefault();
        handleChange(event.target.search.value);
    }}>
        <div className="field">
            <label htmlFor="search" className="label">Search</label>
            <div className="control">
                <input
                    type="text"
                    id="search"
                    name="search"
                    className="input is-large"
                    value={keyword}
                    placeholder="Search By Property Name"
                    onChange={event => handleChange(event.target.value)} />
                <img className="search-icon" src={magnifyingGlassIcon} alt={magnifyingGlassIcon} />
            </div>
        </div>
    </form>
);

Search.propTypes = {
    keyword: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default Search;
